export const QuickReplyIcon = () => {
  return (
    <svg
      fill="#004DBC"
      id="Layer_1"
      version="1.1"
      viewBox="0 0 122.88 98.86"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      y="0px"
    >
      <style type="text/css">{`.st0{fill-rule:evenodd;clip-rule:evenodd;}`}</style>
      <g>
        <path
          className="st0"
          d="M0,49.43l48.93,49.43V74.23c30.94-6.41,55.39,0.66,73.95,24.19c-3.22-48.4-36.29-71.76-73.95-73.31V0L0,49.43 L0,49.43L0,49.43z"
        />
      </g>
    </svg>
  );
};
